import gql from "graphql-tag";

export default gql`mutation DownloadHolidayPaystub($holidayWorkerId: Int!) {
    downloadHolidayPaystub(holidayWorkerId: $holidayWorkerId)
  }`;
